import { useState } from 'react';
import { FAQS } from '@/mocks/trending';

export default function Faq() {
  const [openId, setOpenId] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800 border border-secondary-200">
            <i className="ri-question-line" aria-hidden="true"></i>吃瓜小贴士
          </div>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            关于数据来源、爆瓜预警、热度口径和吃瓜姿势，你想问的都在这里。没找到答案？
            也可以直接留言，瓜小编看到会第一时间回复。
          </p>

          <div className="mt-6 rounded-xl border border-background-200 bg-background-100 p-4 md:p-5">
            <div className="flex items-center gap-2 text-foreground-800">
              <i className="ri-chat-smile-2-line text-primary-500" aria-hidden="true"></i>
              <span className="text-sm font-semibold">还有瓜要吃不懂？</span>
            </div>
            <p className="mt-1 text-xs text-foreground-600">
              留下邮箱订阅瓜讯，每期瓜报准时送达，不迷路。
            </p>
            <a
              href="#subscribe"
              className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-primary-500 px-4 py-2 text-xs font-semibold text-background-50 transition hover:bg-primary-600"
            >
              去订阅
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const open = i === openId;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border transition ${
                  open ? 'border-primary-200 bg-primary-50/60' : 'border-background-200 bg-background-100'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center gap-3 px-4 py-4 text-left"
                >
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-xs font-bold text-primary-600 border border-primary-100">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className="flex-1 text-sm font-semibold text-foreground-950 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 transition ${
                      open ? 'rotate-180 border-primary-300 text-primary-600' : ''
                    }`}
                    aria-hidden="true"
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <p className="border-t border-background-200 px-4 py-4 pl-[52px] pr-4 text-sm leading-relaxed text-foreground-600 md:px-5 md:pl-[60px]">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}